var RESET_LIST = "BUILDERS/RESET_LIST";
var CHANGE_FILTERS = "BUILDERS/CHANGE_FILTERS";
var CHANGE_PAGINATION = "BUILDERS/CHANGE_PAGINATION";
var CHANGE_SELECTION = "BUILDERS/CHANGE_SELECTION";
var CLEAR_STATE = "BUILDERS/CLEAR_STATE";

var resetList = function resetList(id, filters, pagination, selection) {
  return {
    type: RESET_LIST,
    id: id,
    filters: filters,
    pagination: pagination,
    selection: selection
  };
};

var changeFilters = function changeFilters(id, filters) {
  var resetPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: CHANGE_FILTERS,
    id: id,
    filters: filters,
    resetPage: resetPage
  };
};

var changePagination = function changePagination(id, pagination) {
  return {
    type: CHANGE_PAGINATION,
    id: id,
    pagination: pagination
  };
};

var changeSelection = function changeSelection(id, selection) {
  return {
    type: CHANGE_SELECTION,
    id: id,
    selection: selection
  };
};

var clearState = function clearState(id) {
  return {
    type: CLEAR_STATE,
    id: id
  };
};

export { CHANGE_FILTERS, CHANGE_PAGINATION, CHANGE_SELECTION, CLEAR_STATE, RESET_LIST, changeFilters, changePagination, changeSelection, clearState, resetList };
